// react-app-polyfill/ie11 is gone: browserslist here is `not ie <= 11`, so the
// whole point of it was moot, and it dragged in whatwg-fetch and a pile of
// Object/Symbol shims that every browser we target has had for years.
// Lighthouse flagged the lot as "legacy JavaScript", and it all ran at startup.
import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/browser';
import { getEnv, isProd } from './helpers/env';
// Before index.css and, through Root, before App.css -- normalize has to lose
// every specificity tie it enters. Was a cdnjs <link> in index.html.
import './normalize.css';
import './index.css';
import {Root} from './Root';

// This one stays where the Object.values/entries shims next to it did not.
// browserslist still resolves ios_saf 11.0-11.2, and flatMap only landed in
// Safari 12 -- the others were all ES2017 or earlier and safe to drop. Delete
// this the day iOS 11 falls out of the target list.
if(typeof Array.prototype.flatMap !== 'function') {
  const concat = (x,y) => x.concat(y);
  const flatMap = (f,xs) => xs.map(f).reduce(concat, []);
  Array.prototype.flatMap = function(f) { return flatMap(f, this) };
}

if(isProd()) {
	Sentry.init({release: getEnv('RELEASE'), dsn: getEnv('SENTRY_DSN')});
}

ReactDOM.render(<Root />, document.getElementById('root'));
